/* eslint-disable @typescript-eslint/ban-ts-ignore */
import SEO from 'components/Seo';
import cookie from 'helpers/cookie';
import useAppLanguage from 'hooks/use-app-language';
import * as React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { EVENTS, track } from 'utils/analytics';
import { removeOtpTimestamps } from 'utils/otp-timestamps';
import LoginTwoFactor from './LoginTwoFactor';
import LoginUser from './LoginUser';
import messages from './messages';
import { LoginViewState } from './models/LoginViewState';

export default function LoginView() {
  // #region HOOKS
  const history = useHistory();
  const location = useLocation();
  const language = useAppLanguage();
  // #endregion

  // #region STATEW
  const [state, setState] = React.useState<LoginViewState>({
    stepNumber: 1,
    twoFactorToken: '',
  });
  // #endregion

  function onUserLoggedIn() {
    removeOtpTimestamps();
    cookie.set('revix_logged_in', 'true');
    // analytics tracking
    track(EVENTS.LOGIN);
    history.push('/dashboard');
  }

  function onTwoFactorValidated() {
    cookie.set('revix_logged_in', 'true');
    // analytics tracking
    track(EVENTS.LOGIN);
    history.push('/dashboard');
  }

  function onContinueTo2fa(token: string) {
    setState({ stepNumber: 2, twoFactorToken: token });
  }

  function renderActiveStep() {
    switch (state.stepNumber) {
      case 2:
        return (
          <LoginTwoFactor
            twoFactorToken={state.twoFactorToken}
            onTwoFactorValidated={onTwoFactorValidated}
          />
        );
      case 1:
      default:
        return (
          <LoginUser
            onUserLoggedIn={onUserLoggedIn}
            onContinueTo2fa={onContinueTo2fa}
          />
        );
    }
  }

  const loginViewMessages = messages[language].seo;

  return (
    <>
      <SEO
        title={loginViewMessages.title}
        description={loginViewMessages.description}
        keywords={loginViewMessages.keywords}
        page="login"
      />
      <div className="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <div className="justify-center lg:px-8 sm:px-3 sm:py-12">
            {renderActiveStep()}
          </div>
        </div>
      </div>
    </>
  );
}
